import React from 'react'
import { isSetItem } from '../../helpers/Util'
import Image from '../../common/Image'

const DesignImages = ({ designInfo, callback }) => {
    const renderStyleDesignDocuments = () => {
        if (!isSetItem(designInfo)) {
            return (
                <>
                    {designInfo?.designDocuments?.[0]?.docUrl && (
                        <Image
                            src={designInfo?.designDocuments?.[0]?.docUrl}
                            alt='design'
                            className='design-image front'
                            isStatic={false}
                        />
                    )}

                    {designInfo?.backImageDocument?.docUrl && (
                        <Image
                            src={designInfo?.backImageDocument?.docUrl}
                            alt='design'
                            className='design-image back'
                            isStatic={false}
                        />
                    )}
                </>
            )
        }
    }

    return (
        <div
            className={`style-photo cursor-pointer ${
                isSetItem(designInfo) ? 'set-style' : ''
            }`}
            onClick={callback}
        >
            {!isSetItem(designInfo) && renderStyleDesignDocuments()}
            {isSetItem(designInfo) &&
                designInfo?.designDocuments?.map((item) => (
                    <Image
                        key={`set_image_${item.id}`}
                        src={item?.docUrl}
                        alt='design'
                        className='design-image front'
                        isStatic={false}
                    />
                ))}
        </div>
    )
}

export default DesignImages
